
import { fetchStores } from '@/assets/scripts/api'

export default {
  props: {
    filter: { type: Function, default: () => true },
    uiFilters: { type: Array, default: () => [] },
  },

  data() {
    return {
      stores: [],
    }
  },

  async fetch() {
    const storeDataList = await fetchStores()
    this.stores.push(...storeDataList)
  },

  computed: {
    filteredStores() {
      // apply global filter and then ui-filters
      const filters = this.uiFilters && this.uiFilters.length ? this.uiFilters.filter((filter) => filter.enabled) : []

      const applyFilter = filter => item => ({ ...item, disabled: !filter(item) })
      const filtered = this.stores.map(applyFilter(this.filter))

      if (filters.length) {
        return filtered.map(applyFilter((store) => filters.every(f => f.filter(store))))
      }

      return filtered
    },

    filteredListStores() {
      return this.filteredStores.filter(store => !store.disabled)
    },

    markers() {
      const sort = list => list.sort((a, b) => {
        if (a.disabled !== b.disabled) {
          return a.disabled ? -1 : 1
        }
        return 0
      })
      return sort(this.filteredStores.filter(store => store.coordinates))
    },
  },

  methods: {
    select({ coordinates }) {
      if (!this.$refs.mapbox) return
      this.$refs.mapbox.zoomIn(coordinates)
    }
  },
}
